import Vue from 'vue'
import mutations from './mutations'
import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
import apilokacijeprinters from '../../api/printerslocations'
const apiEndpoint = 'printerslocations'

export default {
  namespaced: true,

  state: {
    items: {},
    groupPrinters: {}
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    setCategoryLocationPrinters ({ state, rootState, dispatch }, { categoryId, arejLokacij }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        const promiseLand = []
        arejLokacij.forEach(LocationId => {
          promiseLand.push(apilokacijeprinters.setCategoryLocations({ businessUnitId, categoryId, LocationId }))
        })

        Promise.all(promiseLand)
          .then((res) => {
            dispatch('getCategoryLocationPrinters', { category: categoryId })
              .then(printerjiSkupine => {
                resolve(res)
              })
          })
          .catch(err => reject(err))
      })
    },
    getCategoryLocationPrinters ({ state, rootState, commit }, { category }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        const categoryId = category.id ? category.id : category

        apilokacijeprinters.getCategoryLocations({ businessUnitId, categoryId })
          .then((usp) => {
            const nastavljeniPrinterji = usp.data && usp.data.items ? Object.values(usp.data.items) : null
            const grupaPrinterjev = { ...state.groupPrinters }
            grupaPrinterjev[categoryId] = nastavljeniPrinterji
            commit('setElements', { type: 'groupPrinters', elements: grupaPrinterjev })
            resolve(grupaPrinterjev)
          })
          .catch((err) => reject(err))
      })
    },
    deleteCategoryLocationPrinter ({ state, rootState, commit }, { categoryId, LocationId }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        apilokacijeprinters.deleteCategoryLocations({ businessUnitId, categoryId, LocationId })
          .then(() => {
            const index = state.groupPrinters[categoryId].findIndex(el => el.id === LocationId)
            commit('removeGroupPrinter', { categoryId, index })
            resolve()
          })
          .catch((err) => reject(err))
      })
    }
  },
  mutations: {
    ...mutations,
    removeGroupPrinter (state, { categoryId, index }) {
      Vue.delete(state.groupPrinters[categoryId], index)
    }
  }
}
